export default __webpack_public_path__ + "static/media/icon-use-case.c04165ec.svg";